export default __webpack_public_path__ + "static/media/delete_frame_layout.3f1ec861.svg";